import * as React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Interface-Essential / Delete / delete-2"
}, React.createElement("g", {
  fill: "none",
  stroke: "#808f9a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "data-name": "Group 352"
}, React.createElement("path", {
  "data-name": "Oval 263",
  d: "M12 23.5A11.5 11.5 0 1 0 .5 12 11.5 11.5 0 0 0 12 23.5z"
}), React.createElement("path", {
  "data-name": "Shape 1812",
  d: "M7 7l10 10"
}), React.createElement("path", {
  "data-name": "Shape 1813",
  d: "M17 7L7 17"
})));

var SvgCrossSymbol = function SvgCrossSymbol() {
  return _ref;
};

export default SvgCrossSymbol;